import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Home from './routes/Home';
import Fleet from './routes/Fleet';
import Availability from './routes/Availability';
import Orders from './routes/Orders';
import Repairs from './routes/Repairs';
import Quotations from './routes/Quotations';
import Leads from './routes/Leads';
import Customers from './routes/Customers';
import Certificates from './routes/Certificates';
import Inbox from './routes/Inbox';
import { Aiko } from './aiko/Aiko';

const NAV = [
  { to: '/', label: 'Home', icon: '◉' },
  { to: '/fleet', label: 'Fleet', icon: '⊙' },
  { to: '/availability', label: 'Availability', icon: '◫' },
  { to: '/orders', label: 'Orders', icon: '⊟' },
  { to: '/repairs', label: 'Repairs', icon: '⚙' },
  { to: '/quotations', label: 'Quotes', icon: '◧' },
  { to: '/leads', label: 'Leads', icon: '◐' },
  { to: '/customers', label: 'Customers', icon: '◑' },
  { to: '/certificates', label: 'Certs', icon: '✦' },
  { to: '/inbox', label: 'Aiko Inbox', icon: '☼' },
];

export default function App() {
  const loc = useLocation();
  const [navOpen, setNavOpen] = useState(false);
  useEffect(() => { setNavOpen(false); }, [loc.pathname]);

  return (
    <div className="min-h-dvh flex flex-col md:flex-row">
      <Header onMenu={() => setNavOpen((v) => !v)} />
      <Nav open={navOpen} />
      <main className="flex-1 min-w-0 pb-32 md:pb-24">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fleet" element={<Fleet />} />
          <Route path="/availability" element={<Availability />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/repairs" element={<Repairs />} />
          <Route path="/quotations" element={<Quotations />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Aiko />
    </div>
  );
}

function Header({ onMenu }: { onMenu: () => void }) {
  return (
    <header className="md:hidden sticky top-0 z-30 glass flex items-center justify-between h-12 px-4">
      <button onClick={onMenu} aria-label="Menu" className="w-9 h-9 grid place-items-center rounded-lg hover:bg-elevated">
        <span className="block w-5 h-px bg-ink mb-1.5" /><span className="block w-5 h-px bg-ink" />
      </button>
      <div className="font-semibold tracking-tight">RSME</div>
      <div className="w-9" />
    </header>
  );
}

function Nav({ open }: { open: boolean }) {
  return (
    <nav className={`${open ? 'block' : 'hidden'} md:block md:w-56 md:sticky md:top-0 md:h-dvh md:shrink-0 glass border-r border-line`}>
      <div className="hidden md:flex items-center gap-2 px-4 h-14 border-b border-line">
        <div className="w-7 h-7 rounded-lg bg-accent grid place-items-center text-bg font-bold">R</div>
        <div className="font-semibold tracking-tight">RSME</div>
        <div className="ml-auto text-xs text-muted">v0.1</div>
      </div>
      <ul className="p-2 space-y-0.5">
        {NAV.map((n) => (
          <li key={n.to}>
            <NavLink
              to={n.to}
              end={n.to === '/'}
              className={({ isActive }) =>
                `flex items-center gap-3 h-10 px-3 rounded-lg text-sm transition-colors ${
                  isActive ? 'bg-elevated text-ink' : 'text-muted hover:bg-elevated/60 hover:text-ink'
                }`
              }
            >
              <span className="w-5 text-center text-base">{n.icon}</span>
              <span>{n.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      <div className="mt-auto p-3 text-xs text-muted hidden md:block">
        Built on portal.rsmech.org. Aiko speaks for the agent surface.
      </div>
    </nav>
  );
}

function NotFound() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold">Not found</h1>
      <p className="text-muted mt-2">That route does not exist yet.</p>
    </div>
  );
}
